import { createElement } from "/elements_functions/new_elements.js";

export function createPreviewTypeCircle(nodeWindowPlaque) {
    const existingPreviewTypeCircle = document.querySelector('.select-type-attention-circle');
    const selectSection = nodeWindowPlaque.querySelector('#select-type-section');

    if(!existingPreviewTypeCircle) {
        const selectSectionWidth = selectSection.offsetWidth;
        const selectSectionHeight = selectSection.offsetHeight;
        const rect = selectSection.getBoundingClientRect();

        const offsetLeft = rect.left + selectSectionWidth/2;
        const offsetTop = rect.top + selectSectionHeight/2;
        const previewTypeCircle = createElement('img', null, ['select-type-attention-circle']);
        previewTypeCircle.src = '/images/attention/preview_type_circle.gif';

        previewTypeCircle.style.width = selectSectionWidth * 1.3 - selectSectionHeight/2 +'px';
        previewTypeCircle.style.left = offsetLeft +'px';
        previewTypeCircle.style.top = offsetTop +'px';

        const select = selectSection.querySelector('select');
        select.addEventListener('click', () => previewTypeCircle.remove());

        nodeWindowPlaque.append(previewTypeCircle);
    }

}